
import React, { useState, useEffect, useRef} from 'react';
import { useParams,useNavigate} from 'react-router-dom';
import axios from 'axios';
import { ClickEventArgs } from '@syncfusion/ej2-navigations/src/toolbar/toolbar';
import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective, PdfExport,Selection, Toolbar, Resize } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
import '../App.css';
import AxiosFetchData from '../pages/AxiosFetchData.js'
import { PdfColor, PdfPaddings } from '@syncfusion/ej2-pdf-export';
import Box from '@mui/material/Box';
import { Typography, Modal, 
} from '@mui/material';
 
import { ColumnDirective, ColumnsDirective, TreeGridComponent } from '@syncfusion/ej2-react-treegrid';
//import {  Toolbar } from '@syncfusion/ej2-react-treegrid';
import { getValue } from '@syncfusion/ej2-base';
import * as ReactDOM from 'react-dom';
import VirtualizedSelect from 'react-virtualized-select';
import TextField from '@mui/material/TextField';
import DatePicker from 'react-datepicker'; 
import {apiUrl} from '../pages/UrlParam'; 
import Helper from '../pages/Helper.js';
export const useTaskListHook = (ganttChart) =>{
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [confirmTaskOpen,setConfirmTaskOpen] = useState(false);
    const Navigate = useNavigate();
    const [dataTask, setDataTask] = useState({});
    const [taskName, setTaskName] = useState({});
    const [taskDate, setTaskDate] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [delegasiList, setDelegasiList] = useState([]);
    const [prioritasList, setPrioritasList] = useState([]);
    const [selectedPrioritas, setSelectedPrioritas] = useState('');
    const [action, setAction] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [typeList, setTypeList] = useState([]);
    const [selectedDelegasi, setSelectedDelegasi] = useState('');
    const [kemajuan, setKemajuan] = useState(0);
    const [idTask, setIdTask] = useState('');
    const [confirmDeleteOpen,setConfirmDeleteOpen] = useState(false);
    const [layout, setLayout] = useState('Task');
    const [timelineSetting, setTimelineSetting] = useState({
      timelineUnitSize: 150,
   
        bottomTier: {
       //   timelineUnitSize: 150,
      // count :2,
      count: 1,
        unit: 'Day',
        format: 'MMM dd, yyyy',
        
  }
    });
    const [message, setmessage] = useState('');
    const [tipe, settipe] = useState('');
    const inputRef =  useRef(null);
    const [roleAccess, setRoleAccess] = useState([]);

    useEffect(  () => {
         
          GetTaskList();
          GetStatus();
          GetType();
          GetPrioritas();
          GetDelegasi();
        
      }, []);

    const GetTaskList = async () => {
      try{
        const response = await AxiosFetchData.get(`GetTaskList/${id}`).refreshToken(Navigate,"task");
        if(response){
            setRows(response.data);
           
            // setRows(response.data.map((row, index) => ({
            //   ...row,
            //   sebenarnya_mulai: Helper.GetDateDDMMYYYY(row.sebenarnya_mulai), 
            //   sebenarnya_selesai: Helper.GetDateDDMMYYYY(row.sebenarnya_selesai), 
            // })));
            setRoleAccess(response.roleaccess)
        }

       // console.log(response)
      }catch(e){
        setmessage(e.message);
        settipe('errorlog')
      }
    }

    const AddTask = async (e) => {
      e.preventDefault(); 
       try{
        dataTask.sebenarnya_mulai = taskDate[0]
        dataTask.sebenarnya_selesai = taskDate[1]
        dataTask.status = selectedStatus == null ? null : selectedStatus.value
        dataTask.level = selectedDelegasi == null ? null  : selectedDelegasi.value
        dataTask.prioritas = selectedPrioritas == null ? null : selectedPrioritas.value
        dataTask.type = selectedType
        dataTask.project_id = id
        dataTask.kemajuan = kemajuan

        dataTask.work_day = Helper.GetDay(taskDate[0],taskDate[1])

        if(action == "EditTask"){
            dataTask.id = idTask
        }
       // console.log(dataTask)
        const response = await AxiosFetchData.post(`${action}`, dataTask).refreshToken(Navigate,"task");
        if(response){
            await GetTaskList();

        }
       setConfirmTaskOpen(false)
       setmessage(response.data)
       }catch(e){
          setmessage(e.message)
          settipe('errorlog')
       }
        
    }
 
    const editOptions = {
        allowAdding: true,
        allowDeleting: true,
        allowEditing: true,
        mode: 'Dialog'
    };
    const toolbarOptions = ['PdfExport'];

    let drop;
    const dropdown = (args) => {
       // drop = DataUtil.distinct(projectData, 'Action');
        if (args.column.field === "Action") {
            const val = getValue(args.column.field, args.data);
            ReactDOM.render(<button onClick={(evt) => onChange(evt, args.data, "AddTask")} className='btn btn-danger'  disabled={!roleAccess.CREATE} style={{width:50}}>+</button>, args.cell);
        }

        if (args.column.field === "Edit") {
            const val = getValue(args.column.field, args.data);
            ReactDOM.render(<button onClick={(evt) => onChange(evt, args.data,"EditTask")} disabled={!roleAccess.UPDATE} className='btn btn-success' style={{width:50}}>Edit</button>, args.cell);
        }

        if (args.column.field === "Delete") {
            const val = getValue(args.column.field, args.data);
            ReactDOM.render(<button onClick={(evt) => onDelete(evt, args.data,"DeleteTask")} disabled={!roleAccess.DELETE} className='btn btn-info' style={{width:80}}>Delete</button>, args.cell);
        }
    };

    const onChange = (args,data,tipe) => {
        setTaskName('')
        setTaskDate([])
        setSelectedStatus('')
        setSelectedPrioritas('')
        setSelectedType('')
        setSelectedDelegasi('')
        setAction(tipe);  
        setDataTask(data);

        if(tipe == "EditTask"){
            fetchdata(data.id)
        }
       
        setConfirmTaskOpen(true)
    };

    const onDelete = (args,data,tipe) => {
        setTaskName(data.name)
        setIdTask(data.id)
        //alert(data.id)
        setConfirmDeleteOpen(true)
    }

    async function handleDeleteConfirmation(){
      try{
        const response = await AxiosFetchData.delete(`DeleteTask/${idTask}`).refreshToken(Navigate,"task");
        if(response){
            setConfirmDeleteOpen(false);
            await GetTaskList()
            setmessage(response.data);
        }
      }catch(err){
        setmessage(err.message);
        settipe('errorlog')
      }
        
    }

    async function fetchdata(id){
      try{
        const response = await AxiosFetchData.get(`GetTask/${id}`).refreshToken(Navigate,"task");
        
        if(response){
            
            setSelectedType(response.data.is_milestone);
            setTaskName(response.data.name)
            var data = [...taskDate]
            data[0] = response.data.sebenarnya_mulai == null ? null : new Date(response.data.sebenarnya_mulai);
            data[1] = response.data.sebenarnya_selesai == null ? null : new Date(response.data.sebenarnya_selesai);
            setTaskDate(data);
            setKemajuan(response.data.kemajuan)
            setSelectedStatus(response.data.id_status)
            setSelectedPrioritas(response.data.id_prioritas)
            setSelectedDelegasi(response.data.id_level)
            setIdTask(response.data.id_treeview)
        }
      }catch(err){
          setmessage(err.message)
          settipe('errorlog')
      }
        
    }

    const AddParentTask = () => {
         var data = {
            newName : null,
            id : null
         }
         setAction("AddTask");
         setTaskName('')
         setTaskDate([])
         setSelectedStatus('')
         setSelectedPrioritas('')
         setSelectedType('')
         setSelectedDelegasi('')
         setDataTask(data);
         setConfirmTaskOpen(true)
    };

    function handleTask(data){
        dataTask.newName = data;
        setTaskName(data)
        setDataTask(dataTask)
        
    }

    function handleDate(date,index){
        var data = [...taskDate]
        data[index] = date ;
        setTaskDate(data);
    }

    function  GetStatus(){
        axios.get(`${apiUrl}/api/GetStatus`)
        .then((response) => {
          const transformedOptions = response.data.map((item) => ({
            label: `${item.id} - ${item.name}`,
            value: item.id,
          }));
          setStatusList(transformedOptions);
          //return transformedOptions;
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
    }

    function GetType(){
        var data =[{
            value: '0',
            label: 'Title'
        },{
            value: '2',
            label: 'Milestones'
        },{
            value: '1',
            label: 'Task'
        },
        ]
        setTypeList(data);
    }

    function GetDelegasi(){
        axios.get(`${apiUrl}/api/GetLevel`)
        .then((response) => {
          const transformedOptions = response.data.map((item) => ({
            label: `${item.id} - ${item.name}`,
            value: item.id,
          }));
          setDelegasiList(transformedOptions);
          //return transformedOptions;
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
    }

    function GetPrioritas(){
        axios.get(`${apiUrl}/api/GetPrioritas`)
        .then((response) => {
          const transformedOptions = response.data.map((item) => ({
            label: `${item.id} - ${item.name}`,
            value: item.id,
          }));
          setPrioritasList(transformedOptions);
          //return transformedOptions;
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
        
    }
    const settings = { wrapMode: 'Content' };
    //gantt
    const taskFields = {
        id: 'id',
        name: 'name',
        startDate: 'sebenarnya_mulai',
        endDate: 'sebenarnya_selesai',
        progress: 'kemajuan',
        child: 'subChild',
    };

    const labelSettings = {
      //  leftLabel: 'id',
        rightLabel: '${taskData.name}',
        taskLabel: '${kemajuan}%'
      };

      function ChangeLayout(){
        if(layout == 'Task'){
            setLayout('Gantt')
            //handleTimeline('week')
           handleTimeline('day')
          
        }else{
            setLayout('Task')
           
        }
      }

      function handleTimeline(tipe){
        if(tipe == "month"){
            const timelineSettings = {
                timelineUnitSize: 150,
           
                  bottomTier: {
                 
                  unit: 'Month',
                 
            }
              };
              setTimelineSetting(timelineSettings)
        }else if(tipe == "week"){
            const timelineSettings = {
              timelineUnitSize: 150,
                  bottomTier: {
                 
                  unit: 'Week',
                  format: 'MMM dd, yyyy',
                
            }
              };
              setTimelineSetting(timelineSettings)
        }else{
            const timelineSettings = {
                timelineUnitSize: 100,
             
                  bottomTier: {
                   
                  unit: 'Day',
                  format: 'MMM dd, yyyy',
                  
                } 
              };
              setTimelineSetting(timelineSettings)
              
        }
    
    }
        
    const holidays = [
        {
            from: new Date('10/14/2024'),
            to: new Date('10/14/2024'),
            label: 'Local Holiday'
        },  
    ]

    //let ganttChart;
    function toolbarClick(args) {
    //  alert('aa')
      if (args.item.text === 'PDF export') {
        var exportProperties= {
          //pageOrientation: 'Potraits',
          theme:"Material",
          fontFamily: 1,
         // exportType: 'CurrentViewData',
          pageSize: 'A1',
          fitToWidthSettings: {       
             // isFitToWidth: true,  
            
            // columnHeader: {
            //     backgroundColor: new PdfColor(179, 219, 255)
            // },
            // taskbar: {
            //     taskColor: new PdfColor(240, 128, 128),
            //     taskBorderColor: new PdfColor(240, 128, 128),
            //     progressColor: new PdfColor(205, 92, 92),
            // },
            // connectorLineColor: new PdfColor(128, 0, 0),
            // footer: {
            //     backgroundColor: new PdfColor(205, 92, 92)
            // },
            // timeline: {
            //     backgroundColor: new PdfColor(179, 219, 255),
            //     padding: new PdfPaddings(5, 2, 0, 0),
            // },
            // label: {
            //     fontColor: new PdfColor(128, 0, 0),
            // },
            // cell: {
            //     backgroundColor: new PdfColor(240, 248, 255),
            //     fontColor: new PdfColor(0, 0, 0),
            //     borderColor:new PdfColor(179, 219, 255),
            // },
                
          },
          fileName : "TASKDOC.pdf"      
        };
          // ganttChart.pdfExport({
          //   fileName : "TASK.pdf"
          // });
          ganttChart.pdfExport(exportProperties);
       }
   };

   const  formatOption = { type: 'date', format: 'dd.MM.yyyy' };
   
   return {message,setmessage,tipe,settipe,layout,AddParentTask,roleAccess,handleTimeline,inputRef,ChangeLayout,rows,dropdown,
            settings,taskFields,labelSettings,timelineSetting,toolbarOptions,toolbarClick,confirmTaskOpen,setConfirmTaskOpen,
            AddTask,typeList,setSelectedType,selectedType,taskName,handleTask,handleDate,taskDate,statusList,setSelectedStatus,selectedStatus,
            kemajuan,setKemajuan,confirmDeleteOpen,setConfirmDeleteOpen,handleDeleteConfirmation
   }
}